module.exports = __webpack_public_path__ + "static/img/14000660.b01968cb.png";